/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { News } from '../models/News';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NewsService {
    /**
     * GetNews
     * @returns News Ответ запроса новостей
     * @throws ApiError
     */
    public static getNews(): CancelablePromise<News> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/news',
        });
    }
}
